import { useEffect, useState } from 'react';
import dayjs from 'dayjs';

import { useServerTime } from './useServerTime';

const ONE_MINUTE_IN_MILLISECONDS = 60 * 1000;

const useCurrentTime = (
  refreshInterval: number = ONE_MINUTE_IN_MILLISECONDS
) => {
  const { serverTime } = useServerTime();

  const [currentTime, setCurrentTime] = useState(() =>
    dayjs(serverTime * 1000)
  );

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(dayjs());
    }, refreshInterval);

    return () => clearInterval(intervalId);
  }, [refreshInterval]);

  return { currentTime };
};

export { useCurrentTime };
